import { CostCarrierConfig } from '@app/icare/entities/costCarrier/config'
import { patientCostCarrierQueries } from '@app/icare/entities/costCarrier/queries/patientCostCarrierQueries'
import { PatientCostCarrierEditDrawer } from '@app/icare/entities/patient/edits/PatientCostCarrierEditDrawer'
import {
  patientFindingsQueryOptions,
  selectByGroupAndGroupByRelationId,
} from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientCostCarrierRelation } from '@app/icare/entities/patient/schema/PatientCostCarrier'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { useRelationCommitNavigation } from '@app/icare/routes/_app/patienten/$id/_edit/-components/useRelationCommitNavigation'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_costCarrier/kostentraeger/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientCostCarrierQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()
  const { data: costCarriers = [] } = useSuspenseQuery(patientCostCarrierQueries.forIndex(id))
  const { data: findings = {} } = useQuery({
    ...patientFindingsQueryOptions(id),
    select: selectByGroupAndGroupByRelationId('costCarriers'),
  })

  const handleAfterCommit = useRelationCommitNavigation<PatientCostCarrierRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/kostentraeger/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })

  return (
    <RelationOverview
      items={costCarriers}
      labels={CostCarrierConfig}
      findings={findings}
      basePath={`/patienten/${id}/kostentraeger`}
      onEdit={params =>
        void PatientCostCarrierEditDrawer.show({
          patientId: id,
          onAfterCommit: handleAfterCommit,
          ...params,
        })
      }
    />
  )
}
